import { render, staticRenderFns } from "./spaceRequestsAll.vue?vue&type=template&id=f97fc276&scoped=true&"
import script from "./spaceRequestsAll.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsAll.vue?vue&type=script&lang=js&"
import style0 from "./spaceRequestsAll.vue?vue&type=style&index=0&id=f97fc276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97fc276",
  null
  
)

export default component.exports